import { Component, h, Element, Listen, State } from '@stencil/core';

@Component({
  tag: 'spw-accordion-content',
  styleUrl: 'spw-accordion-content.scss',
  shadow: true,
})
export class SpwAccordionContent {
  @Element() el: HTMLSpwAccordionContentElement;
  private contentElement: HTMLElement;

  @State() isOpened: boolean = false;

  componentDidLoad() {
    this.assignItemId();
    this.updateHeight();
    window.addEventListener('resize', this.handleResize.bind(this));
    this.contentElement.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize.bind(this));
    this.contentElement.removeEventListener('transitionend', this.handleTransitionEnd.bind(this));
  }

  private assignItemId() {
    const parent = this.el.closest('spw-accordion-item');
    if (parent) {
      const itemId = parent.getAttribute('data-accordion-id');
      if (itemId) {
        this.el.setAttribute('data-accordion-id', itemId);
      }
    }
  }

  @Listen('accordionToggle', { target: 'document' })
  handleAccordionToggle(event: CustomEvent<{ isOpen: boolean; id: string }>) {
    const itemId = this.el.getAttribute('data-accordion-id');
    if (event.detail.id === itemId) {
      this.isOpened = event.detail.isOpen;
      this.updateHeight();
    }
  }

  private handleResize() {
    this.updateHeight();
    setTimeout(() => {
      this.updateHeight();
    }, 300);
  }

  private handleTransitionEnd(event: TransitionEvent) {
    if (event.propertyName === 'max-height') {
      if (this.isOpened) {
        this.contentElement.classList.add('spw-accordion-content--is-opened');
      } else {
        this.contentElement.classList.remove('spw-accordion-content--is-opened');
      }
    }
  }

  private updateHeight() {
    requestAnimationFrame(() => {
      const content = this.contentElement;
      if (this.isOpened) {
        const scrollHeight = content.scrollHeight;
        content.style.maxHeight = `${scrollHeight}px`;
      } else {
        content.style.maxHeight = '0px';
      }
    });
  }

  render() {
    return (
      <div class="spw-accordion-content" ref={el => (this.contentElement = el)} data-accordion-id={this.el.getAttribute('data-accordion-id')}>
        <div class="spw-accordion-content__inner">
          <slot onSlotchange={() => this.updateHeight()}></slot>
        </div>
      </div>
    );
  }
}
